<template>
  <el-dialog
    append-to-body
    width="500px"
    title="已取消"
    center
    :visible.sync="visible"
    :before-close="reset"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <el-form
      v-loading="loading"
      element-loading-text="加载中…"
      ref="elFormDom"
      label-width="110px"
      label-position="right"
      :model="form.data"
      :rules="form.rules"
    >
      <el-form-item prop="name" label="姓名：">
        {{ info.nickname }}
      </el-form-item>
      <el-form-item prop="name" label="注册号码：">
        {{ info.account }}
      </el-form-item>
      <el-form-item prop="name" label="学历：">
        {{ info.education_str }}
      </el-form-item>
      <el-form-item prop="name" label="毕业院校：">
        <div style="display: flex;align-items: center;">
          <div>{{ info.school_str }}</div>
          <el-tag style="margin-left:6px" v-if="info&&info.college_type_str&&info.college_type_str.includes('985')" size="mini" type="success">985</el-tag>
          <el-tag style="margin-left:6px" v-if="info&&info.college_type_str&&info.college_type_str.includes('211')" size="mini" type="warning">211</el-tag>
        </div>
      </el-form-item>
      <el-form-item prop="name" label="专业：">
        {{ info.major_str }}
      </el-form-item>
      <el-form-item prop="name" label="提交时间：">
        {{ info.create_time }}
      </el-form-item>
      <el-form-item prop="name" label="取消时间：">
        {{ info.cancel_time }}
      </el-form-item>
      <el-form-item prop="name" label="取消原因：">
        {{ info.cancel_reason }}
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      info: {},
      visible: false,
      loading: false,
      form: {
        loading: false,
        data: {
          date: "",
        },
        rules: {
          date: [{ required: true, message: "必填项", trigger: "change" }],
        },
      },
    };
  },
  created() {},
  methods: {
    reset(done) {
      this.info = {};
      this.$refs.elFormDom.resetFields();
      done && done();
    },
    toggle(show) {
      this.visible = show;
      !show && this.reset();
    },
    getDetail(row) {
      this.info = row;
    },
    // 提交
    confirm() {
      this.$refs.elFormDom.validate((valid) => {
        if (valid) {
          this.form.loading = true;
          let params = {
            id: this.info.id,
            date: this.form.data.date,
          };
          this.$http
            .post("/admin/order/dimission", params)
            .then((res) => {
              if (res.code === 1) {
                this.toggle(false);
                this.$emit("refresh");
              }
            })
            .finally(() => {
              this.form.loading = false;
            });
        }
      });
    },
    toReject() {
      this.$prompt("请输入拒绝理由（100字之内）", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /\S+/,
        inputErrorMessage: "请输入驳回原因",
        inputPlaceholder: "请输入驳回原因",
      });
    },
  },
};
</script>
